import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFormDelegate, IFormOptions, LANGUAGES } from '@modeso/aumico-lib-core-fe';
import { IDynamicKeyValue, INameId } from '@modeso/types__aumico-lib-core-be';
import { ITemplateGroupMappingItemSubFli } from '@modeso/types__aumico-lib-templates-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { omit } from 'lodash-es';
import { ISubFliFormDialogResult } from '../../interfaces/sub-fli-form-dialog-result.interface';

@UntilDestroy()
@Component({
    // tslint:disable-next-line: component-selector
    selector: 'templates-admin-sub-fli-form',
    templateUrl: 'sub-fli-form-dialog.component.html',
    styleUrls: ['sub-fli-form-dialog.component.scss'],
})
export class AdminSubFliFormDialog implements OnInit {
    public options: IFormOptions;
    public formDelegate: IFormDelegate;

    public languages: INameId[];

    private languageToText: IDynamicKeyValue = {};
    private currentSelectedLanguage: string;
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<AdminSubFliFormDialog, ISubFliFormDialogResult | undefined>,
        private formBuilder: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA)
        public data: { languages: string[]; subfliToBeEdited?: ITemplateGroupMappingItemSubFli },
    ) {
        this.languages = data.languages.map((language) => ({ name: language, id: language.toLowerCase() }));
        this.currentSelectedLanguage = LANGUAGES.SWISS_GERMAN;
    }

    ngOnInit(): void {
        this.initFromControls();
    }

    private initFromControls(): void {
        this.form = this.formBuilder.group({
            name: new FormControl<string>('', [Validators.required]),
            language: new FormControl<INameId>({ name: 'de-CH', id: LANGUAGES.SWISS_GERMAN }, [Validators.required]),
            caption: new FormControl<string>('', [Validators.required]),
            isOfThatItem: new FormControl<boolean>(false),
        });

        const { subfliToBeEdited } = this.data;
        if (subfliToBeEdited != null) {
            this.onEditSubfli(subfliToBeEdited);
        }
    }

    public save(): void {
        const { caption, language } = this.form.value;
        this.languageToText[language.id] = caption;

        const subFliResult: ITemplateGroupMappingItemSubFli = {
            ...omit(this.form.getRawValue(), 'language'),
            caption: this.languageToText,
        };

        this.dialogRef.close(subFliResult);
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }

    public onLanguageSelectionChange(): void {
        const { caption, language } = this.form.getRawValue();

        if (this.currentSelectedLanguage != null && caption != null) {
            this.languageToText[this.currentSelectedLanguage] = caption;
        }
        this.currentSelectedLanguage = language.id;

        if (this.languageToText[this.currentSelectedLanguage] != null) {
            const savedTextValue = this.languageToText[this.currentSelectedLanguage];
            this.form.get('caption').setValue(savedTextValue);
        } else {
            this.form.get('caption').reset();
        }
    }

    private onEditSubfli(subfliToBeEdited: ITemplateGroupMappingItemSubFli) {
        this.form.get('name').disable();
        this.form.patchValue(subfliToBeEdited);

        this.form.get('caption').setValue(subfliToBeEdited.caption[LANGUAGES.SWISS_GERMAN]);
        this.languageToText = subfliToBeEdited.caption;
    }
}
